import * as React from "react";
import { Divider, Typography, Toolbar, Box, Drawer ,alpha} from "@mui/material";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useStyles } from "./sidebar-styles";
import { UserCard } from "./UserCard";
import { SideBarOptions } from "./SideBarOptions";
import { useDispatch, useSelector } from "react-redux";
import { useTheme, useMediaQuery } from "@mui/material";

const drawerWidth = 290;

export default function PermanentDrawerLeft() {
  const classes = useStyles();
  // const dispatch = useDispatch();
  const showDrawer = useSelector((state) => state.ui.showDrawer);
  const theme = useTheme();
  // const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  // const [showDrawer, setShowDrawer] = React.useState(true);

  return (
    <>
      <Drawer
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            // outline: '1px solid ' + theme.palette.text.main
            //  height:"20rem"
          },

        

          //   '*::-webkit-scrollbar-track': {
          //   '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
          // },

          "*::-webkit-scrollbar-thumb": {
            backgroundColor: alpha(theme.palette.primary.main,.3),
            // "&:hover": {
            //   backgroundColor: "red",
            // },

            // outline: '1px solid slategrey'
          },
        }}
        variant={showDrawer ? "permanent" : "temporary"}
        open={showDrawer}
        anchor="left"
      >
        <Divider />

        <Toolbar className={classes.toolbar}>
          <Typography variant="h6">React Dashboard</Typography>
          <Box sx={{ flex: 3 }}></Box>
          <MenuOutlinedIcon />
        </Toolbar>


        <UserCard />

        <Divider />
        <SideBarOptions />
      </Drawer>
    </>
  );
}
